import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const HomeLabSolutions = () => {
  return (
    <div id='website-responsive'>
        <div className=''>
            <div className='bg-img py-md-5 py-5' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/04/Laboratory-Tests-Section-Background.jpg")', height:'100%', width:'100%'}}>
                <div className='py-md-5 py-2'>
                    <text className='fs-ss-56-1 text-montserrat fw-700 text-white lh-1-4' style={{ textShadow:'2px 2px 10px rgba(0,0,0,.3)', letterSpacing:'-1px'}}>
                        <center>
                            Bringing the Right Lab Solutions, <br/>
                            For Your Health Problems!
                        </center>
                    </text>
                </div>
                <div className='pb-md-5 pb-4 pt-3'>
                    <center>
                    <Link to='/book-appointment'>
                        <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                            <text className='text-montserrat fw-600 fs-ss-18' style={{ padding:'12px 14px',}}>
                                Book Appointment
                            </text>
                        </Button>
                    </Link>
                    </center>
                </div>
            </div>
        </div>
    </div>
  )
}

export default HomeLabSolutions